import { AuthSession, FetchUserAttributesOutput } from 'aws-amplify/auth';
import { Observable } from 'rxjs';

export abstract class AuthGateway {
  abstract fetchAuthSession(forceRefresh?: boolean): Observable<AuthSession>;
  abstract fetchUserAttributes(): Observable<FetchUserAttributesOutput>;
  abstract signInWithRedirect(): Observable<void>;
}
